import React from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
// import '../../styles/main.scss';
import './Layout.scss';

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
      </Helmet>
      <div className="layout__container">
        <Navbar />
        <main className="layout__content">{children}</main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
